// extracted by mini-css-extract-plugin
module.exports = {"singup-form":"Signup_singup-form__2P93L"};